import cs from 'classnames'
import type React from 'react'

import type { AttachmentItem } from '@/types'
import { AttachedFileWrapper } from '../AttachedFileWrapper'
import { FileIcon } from '../FileIcon'
import css from './DocumentThumbnail.module.scss'
import { splitFilename } from './utils'

interface Props {
  data: AttachmentItem
  selected: boolean
}

export const DocumentThumbnail: React.FC<Props> = ({ data, selected }) => {
  const [name, extension] = splitFilename(data.filename)
  const onDoubleClick = () => {
    window.open(data.downloadUrl, '_blank')
  }

  return (
    <AttachedFileWrapper selected={selected}>
      <div className={css.container} onDoubleClick={onDoubleClick}>
        <div className={css.iconWrapper}>
          <FileIcon extension={extension} />
        </div>
        <span className={cs(css.title, css.lineClamp)}>{name}</span>
      </div>
    </AttachedFileWrapper>
  )
}
